module.exports = __webpack_public_path__ + "img/report-disabled.21753472.png";